// extracted by mini-css-extract-plugin
export default {"status":"style_status__DNiJj"};